import { Briefcase, Globe, MicVocal } from 'lucide-react';
import LinkedInIcon from '@/app/[locale]/components/widgets/LinkedInIcon';

export const speakerData = {
  name: "Sascha Sambale",
  email: "kontakt@sascha-sambale.de",
  imprintEmail: "kontakt@sascha-sambale.de",
  jobTitle: "AI Keynote Speaker, Enterprise AI Transformation Consultant, AI Consultant for SMEs & GEO Consultant",
  company: "SygentiQ GmbH",
  companyUrl: "https://sygentiq.com",
  url: "https://sascha-sambale.de",
  image: "/images/hero-background.jpeg",
  imageUrl: "/images/about_sascha_sambale.webp",
  socialLinks: {
    linkedin: "https://www.linkedin.com/in/saschasambale/",
    twitterHandle: "SaschaSambale",
  },
  basePrice: "3000",
  currency: "EUR",
  lastUpdated: "2026-09-21",
  bio1Key: 'bio1',
  bio2Key: 'bio2',
  stats: [
    {
      value: "4K+",
      labelKey: 'stats.linkedinFollowers',
      Icon: LinkedInIcon,
    },
    {
      value: "50+",
      labelKey: 'stats.globalAppearances',
      Icon: Globe,
    },
    {
      value: "15+",
      labelKey: 'stats.yearsOfExperience',
      Icon: Briefcase,
    },
    {
      value: "50k+",
      labelKey: 'stats.clientSatisfaction',
      Icon: MicVocal,
    },
  ],
  bookingInfo: {
    basedIn: "Bretzfeld, Hohenlohe, Heilbronn, Germany",
    address: {
      streetName: "Merowingerstraße",
      houseNumber: "39",
      city: "Bretzfeld",
      zipCode: "74626",
      state: "Baden-Württemberg",
      country: "Germany",
      country_ISO: "DE"
    },
    availability: "Currently accepting bookings 2-8 months in advance",
    duration: {
      keynotes: "30-90 min",
      workshops: "2-8 hours",
      trainings: "0.5-3 days"
    },
    audience: "From executive meetings to conferences with 1000+ attendees"
  },
  knowsAbout: [
    "AI Keynote Speaking",
    "Executive & Technical Storytelling",
    "Generative AI for Business",
    "Enterprise AI Transformation",
    "AI Strategy",
    "AI Use Case Prioritization",
    "ROI-driven AI Implementation",
    "AI Governance",
    "Responsible AI",
    "AI Agents & Agentic AI",
    "Multi-Agent Systems",
    "Workflow Automation",
    "AI ROI Calculation & Business Cases",
    "AI Roadmaps for SMEs and Mid-Sized Companies",
    "Internal AI Champion Enablement",
    "AI Model Selection (Frontier, Small and Open-Weight Models)",
    "Fine-Tuning vs. RAG Decisions",
    "EU AI Act Compliance",
    "Large Language Models",
    "AI Architecture",
    "Prompt Engineering",
    "RAG (Retrieval-Augmented Generation)",
    "Cloud Computing",
    "Software Engineering",
    "Generative Engine Optimization (GEO)",
    "SEO & AI Search Visibility Analysis",
    "LLM Citability & AI Overview Optimization",
    "GDPR-Compliant AI Use",
    "AI Agents vs. RPA (Robotic Process Automation)",
    "AI Maturity Model & Readiness Assessment",
    "AI Guidelines for Employees",
    "Change Management for AI Adoption",
    "Data Privacy & AI Compliance",
    "AI Strategy for SMEs (KMU) & Mittelstand",
    "RAG Implementation with Company Data",
    "Private AI & On-Premises / Open-Weight LLM Deployment",
    "Custom AI Software Development",
    "LLM Implementation for SMEs and Mid-Sized Companies"
  ],
  jsonLd: {
    description: "Sascha Sambale is a German AI keynote speaker, enterprise AI transformation consultant, AI consultant for SMEs, KMUs and the Mittelstand, and GEO consultant based in Bretzfeld, Hohenlohe, between Heilbronn and Stuttgart in Baden-Württemberg. He speaks and consults on generative AI strategy, AI potential assessment and AI maturity, AI use case prioritization and ROI, AI governance, EU AI Act and GDPR compliance, AI agents vs. RPA, RAG implementation, Private AI and on-premises LLM deployment, and Generative Engine Optimization (GEO) for AI search visibility. As former Global GenAI Lead at Robert Bosch GmbH he led the introduction of generative AI across global corporate structures, which is why he delivers both board-level keynotes and deep technical sessions for engineering teams. Available for keynotes (30–90 min), executive briefings, workshops, corporate training, AI implementation projects, and AI transformation mandates for large enterprises and mid-sized companies across the DACH region and internationally.",
    alumniOf: {
      "@type": "Organization",
      "name": "Robert Bosch GmbH"
    },
    areaServed: ["DE", "AT", "CH", "EU"],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      "name": "AI Keynote & Consulting Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "name": "AI Keynote & Leadership Roundtable",
          "description": "Keynote (30–90 min) on AI opportunities and risks for businesses, followed by a leadership discussion to derive concrete next steps. Suitable for conferences and internal executive events.",
          "priceRange": "€2,500–€6,500",
          "priceCurrency": "EUR",
          "availableLanguage": ["German", "English"]
        },
        {
          "@type": "Offer",
          "name": "Executive GenAI Briefing",
          "description": "Compact 2–3 hour executive session on where generative AI creates business value, what risks to manage, and which strategic decisions leadership must make now.",
          "priceRange": "€1,500–€3,000",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "AI Value Discovery Workshop",
          "description": "Full-day workshop to identify high-value AI use cases, assess business impact and feasibility, and produce a prioritized use-case shortlist with recommended next steps.",
          "priceRange": "€2,500–€3,500",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "AI Enablement & Training Program",
          "description": "Hands-on training for business and technical teams covering prompting, AI tools, workflow redesign, and responsible AI adoption.",
          "priceRange": "€1,200–€3,500",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "Enterprise AI Transformation Blueprint",
          "description": "Design of a full AI adoption roadmap including governance, stakeholder alignment, enablement strategy, and implementation priorities for large enterprises.",
          "priceRange": "€3,500–€7,500",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "AI ROI & Use-Case Assessment",
          "description": "Two to three day assessment that evaluates AI use cases against a measured baseline by business value, effort, risk, and data availability - including the investment side (model selection, integration, governance, total cost of ownership) - and delivers a prioritized shortlist with a business case per use case.",
          "priceRange": "€2,500–€6,000",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "AI Agent Discovery Sprint",
          "description": "Five-day sprint for teams launching their first AI agent: identifying the process steps where an agent genuinely pays off, feasibility assessment, guardrails and human-in-the-loop design, and a solid pilot plan.",
          "priceRange": "€4,000–€9,000",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "AI Architecture Review",
          "description": "Independent three to five day review of AI architecture, model selection, agent patterns, data access, automation risks, and implementation options for CTOs and digital leads.",
          "priceRange": "€3,000–€7,500",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "AI Potential Assessment & AI Maturity Workshop",
          "description": "One-day workshop that assesses a company's AI maturity stage, analyzes processes and business potential, prioritizes valuable AI use cases, and produces a realistic AI roadmap with concrete next steps - scaled to SMEs and mid-sized companies (Mittelstand) that don't need a large AI department to start.",
          "priceRange": "€2,000–€3,500",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "RAG Implementation & Custom AI Software Development",
          "description": "Architecture and implementation of Retrieval-Augmented Generation (RAG) systems, AI agents, LLM integrations, and open-weight or Private AI setups - from data preparation and model selection to production integration into existing applications and processes.",
          "priceRange": "On request, scope-dependent",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "EU AI Act & GDPR-Compliant AI Adoption",
          "description": "Practical support building an internal AI inventory, classifying AI systems by EU AI Act risk category, developing AI guidelines and AI literacy training for employees, and aligning AI use with GDPR requirements.",
          "priceRange": "€1,500–€4,500",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "name": "GEO & AI Search Visibility Audit",
          "description": "Structured Generative Engine Optimization (GEO) audit and implementation for company or personal-brand websites: technical SEO fundamentals, schema.org/JSON-LD structured data, AI crawler access policies, and content citability optimization to improve visibility in ChatGPT, Claude, and Perplexity - grounded in the same crawlability and content-quality fundamentals that govern Google Search and AI Overviews.",
          "priceRange": "€1,200–€3,500",
          "priceCurrency": "EUR"
        }
      ]
    }
  }
};
